// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*------------------------------------------------------------ DS Solo Home Page Start -----*/

.tophm_solo {
  padding: 7px 0;
}
.tophm_solo p {
  color: #e1251b;
  margin: 0px;
  font-weight: 600;
  line-height: 2.2;
}

.home_banner {
  position: relative;
  margin-bottom: 20px;
}
.home_banner .sm_stamp {
  position: absolute;
  top: 20%;
  left: 10%;
  width: 230px;
}
.solohome_tumbs {
  background-color: #071822;
  text-align: center;
  padding: 20px;
}
.solohome_tumbs h1 {
  color: #ffffff;
  font-size: 25px;
}
.solohome_tumbs p {
  color: #ffffff;
  font-size: 20px;
}
.solohome_tumbs .card_item {
  background-color: #f0f1f7;
  padding-top: 80px;
}
.solohome_tumbs .halftop_img img {
  width: 110px;
}
.solohome_tumbs .halftop_img {
  position: absolute;
  transform: translate(-50%, -110%);
  background-color: #fff;
  display: inline-block;
  border-radius: 50%;
  width: 125px;
  height: 125px;
  line-height: 120px;
  left: 50%;
  box-shadow: 0px 2px 5px rgba(203, 226, 239, 1);
}
.solohome_tumbs .card_footer {
  height: 90px;
}
.solohome_tumbs .card_footer h5 {
  color: #e1251b;
}

.solohome_section_banner {
  background-size: cover;
}
.solohome_section h4 {
  font-size: 30px;
}
.solohome_section p {
  font-family: "futura_bk_btbook", sans-serif;
  font-size: 25px;
  color: var(--textclr1);
}

.banner-social li a {
  color: var(--main-color);
  font-size: 20px;
  padding: 0px 5px;
}


@media screen and (min-width: 768px) and (max-width: 1024px) {
  .solohome_tumbs .halftop_img {
    transform: translate(-50%, -110%);
    width: 60px;
    height: 60px;
    line-height: 55px;
    left: 50%;
  }
  .solohome_tumbs .card_item {
    padding-top: 35px;
  }
  .solohome_tumbs .halftop_img img {
    width: 50px;
  }
  .solohome_tumbs .card_footer {
    height: 50px;
  }
  .solohome_tumbs .card_footer h5 {
    color: #e1251b;
    font-size: 15px;
  }
  .home_banner .sm_stamp {
    width: 180px;
  }
}

@media screen and (max-width: 992px) {
  .home_banner .sm_stamp {
    width: 120px;
  }
}
@media screen and (max-width: 767px) {
  .home_banner .sm_stamp {
    width: 80px;
  }
  .solohome_tumbs h1 {
    color: #ffffff;
    font-size: 20px;
  }
  .solohome_tumbs p {
    color: #ffffff;
    font-size: 15px;
  }
  .solohome_tumbs .card_item {
    margin-bottom: 80px;
  }
}
@media screen and (max-width: 530px) {
  .solohome_tumbs h1 {
    color: #ffffff;
    font-size: 15px;
  }
  .solohome_tumbs p {
    color: #ffffff;
    font-size: 10px;
  }
  .solohome_tumbs .container {
    padding: 0px;
  }
  .solohome_tumbs .halftop_img img {
    width: 50px;
  }
  .solohome_tumbs .halftop_img {
    transform: translate(-50%, -110%);
    width: 60px;
    height: 60px;
    line-height: 55px;
    left: 50%;
  }
  .solohome_tumbs .card_item {
    padding-top: 35px;
  }
  .solohome_tumbs .card_footer h5 {
    font-size: 13px;
  }
  .solohome_tumbs .card_footer {
    height: 50px;
  }
  .solohome_tumbs .mrgbtm-100 {
    margin-bottom: 50px;
  }
  .solohome_tumbs .card_item {
    margin-bottom: 50px;
  }
  .solohome_section h4 {
    font-size: 20px;
  }
  .solohome_section p {
    font-size: 15px;
  }
}



`, "",{"version":3,"sources":["webpack://./app/pages/Transferee/solo/solo.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,8CAA8C;AAChD;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE;IACE,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/*------------------------------------------------------------ DS Solo Home Page Start -----*/\n\n.tophm_solo {\n  padding: 7px 0;\n}\n.tophm_solo p {\n  color: #e1251b;\n  margin: 0px;\n  font-weight: 600;\n  line-height: 2.2;\n}\n\n.home_banner {\n  position: relative;\n  margin-bottom: 20px;\n}\n.home_banner .sm_stamp {\n  position: absolute;\n  top: 20%;\n  left: 10%;\n  width: 230px;\n}\n.solohome_tumbs {\n  background-color: #071822;\n  text-align: center;\n  padding: 20px;\n}\n.solohome_tumbs h1 {\n  color: #ffffff;\n  font-size: 25px;\n}\n.solohome_tumbs p {\n  color: #ffffff;\n  font-size: 20px;\n}\n.solohome_tumbs .card_item {\n  background-color: #f0f1f7;\n  padding-top: 80px;\n}\n.solohome_tumbs .halftop_img img {\n  width: 110px;\n}\n.solohome_tumbs .halftop_img {\n  position: absolute;\n  transform: translate(-50%, -110%);\n  background-color: #fff;\n  display: inline-block;\n  border-radius: 50%;\n  width: 125px;\n  height: 125px;\n  line-height: 120px;\n  left: 50%;\n  box-shadow: 0px 2px 5px rgba(203, 226, 239, 1);\n}\n.solohome_tumbs .card_footer {\n  height: 90px;\n}\n.solohome_tumbs .card_footer h5 {\n  color: #e1251b;\n}\n\n.solohome_section_banner {\n  background-size: cover;\n}\n.solohome_section h4 {\n  font-size: 30px;\n}\n.solohome_section p {\n  font-family: \"futura_bk_btbook\", sans-serif;\n  font-size: 25px;\n  color: var(--textclr1);\n}\n\n.banner-social li a {\n  color: var(--main-color);\n  font-size: 20px;\n  padding: 0px 5px;\n}\n\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .solohome_tumbs .halftop_img {\n    transform: translate(-50%, -110%);\n    width: 60px;\n    height: 60px;\n    line-height: 55px;\n    left: 50%;\n  }\n  .solohome_tumbs .card_item {\n    padding-top: 35px;\n  }\n  .solohome_tumbs .halftop_img img {\n    width: 50px;\n  }\n  .solohome_tumbs .card_footer {\n    height: 50px;\n  }\n  .solohome_tumbs .card_footer h5 {\n    color: #e1251b;\n    font-size: 15px;\n  }\n  .home_banner .sm_stamp {\n    width: 180px;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .home_banner .sm_stamp {\n    width: 120px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .home_banner .sm_stamp {\n    width: 80px;\n  }\n  .solohome_tumbs h1 {\n    color: #ffffff;\n    font-size: 20px;\n  }\n  .solohome_tumbs p {\n    color: #ffffff;\n    font-size: 15px;\n  }\n  .solohome_tumbs .card_item {\n    margin-bottom: 80px;\n  }\n}\n@media screen and (max-width: 530px) {\n  .solohome_tumbs h1 {\n    color: #ffffff;\n    font-size: 15px;\n  }\n  .solohome_tumbs p {\n    color: #ffffff;\n    font-size: 10px;\n  }\n  .solohome_tumbs .container {\n    padding: 0px;\n  }\n  .solohome_tumbs .halftop_img img {\n    width: 50px;\n  }\n  .solohome_tumbs .halftop_img {\n    transform: translate(-50%, -110%);\n    width: 60px;\n    height: 60px;\n    line-height: 55px;\n    left: 50%;\n  }\n  .solohome_tumbs .card_item {\n    padding-top: 35px;\n  }\n  .solohome_tumbs .card_footer h5 {\n    font-size: 13px;\n  }\n  .solohome_tumbs .card_footer {\n    height: 50px;\n  }\n  .solohome_tumbs .mrgbtm-100 {\n    margin-bottom: 50px;\n  }\n  .solohome_tumbs .card_item {\n    margin-bottom: 50px;\n  }\n  .solohome_section h4 {\n    font-size: 20px;\n  }\n  .solohome_section p {\n    font-size: 15px;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
